const Loading = () => {
  return (
    <div className="self-center flex  justify-center h-full">
      <span className="loading loading-spinner loading-lg"></span>
    </div>
  );
};

export default Loading;
